import React from "react";
import _ from "lodash";

import { getDisplayName } from "Utils/HOCHelpers";

/**
 * Purpose:
 * Currently, we use mapStateToProps to access redux store and compute props required for below HOC.
 * While this is a good approach on surface, it has below issues:
 * - mapStateToProps is called on every store change, so we are doing lot of unnecessary computation.
 * - If computation involves changing references, corresponding components will re-render even if it should not re-render.
 *
 * To solve above issues, we can use mapStateToProps only for extacting data from redux in original form and we can leverage
 * getDerivedProps function from this HOC to do all kinds of computations. Since, getDerivedProps will be called less
 * frequently than mapStateToProps, we can do all kinds of computations here without worrying about performance.
 */

const withDerivedProps = (getDerivedProps = _.identity) => Component => {
  const WithDerivedProps = props => {
    const derivedProps = getDerivedProps(props);
    return <Component {...props} {...derivedProps} />;
  };

  WithDerivedProps.displayName = `WithDerivedProps(${getDisplayName(
    Component
  )})`;

  return WithDerivedProps;
};

export default withDerivedProps;
